// Helpers partages du module Cantine scolaire.

export const formatMontant = (value) =>
  `${Math.round(Number(value || 0)).toLocaleString('fr-FR').replace(/,/g, ' ')} FCFA`;

export const formatNumber = (value) => new Intl.NumberFormat('fr-FR').format(Number(value || 0));

// Jours ISO : 1 = lundi ... 7 = dimanche (aligne sur le backend)
export const JOURS_SEMAINE = [
  { value: 1, label: 'Lundi', court: 'Lun' },
  { value: 2, label: 'Mardi', court: 'Mar' },
  { value: 3, label: 'Mercredi', court: 'Mer' },
  { value: 4, label: 'Jeudi', court: 'Jeu' },
  { value: 5, label: 'Vendredi', court: 'Ven' },
  { value: 6, label: 'Samedi', court: 'Sam' },
  { value: 7, label: 'Dimanche', court: 'Dim' }
];

export const REGIMES_FACTURATION = [
  {
    value: 'forfait',
    label: 'Forfait',
    description: "L'élève est abonné : il paie un montant fixe, qu'il mange ou non."
  },
  {
    value: 'occasionnel',
    label: 'Occasionnel',
    description: 'Le repas est payé à la journée, avant le service.'
  }
];

export const SEVERITES_RESTRICTION = [
  { value: 'critique', label: 'Critique', badge: 'bg-red-100 text-red-800' },
  { value: 'important', label: 'Important', badge: 'bg-orange-100 text-orange-800' },
  { value: 'info', label: 'Information', badge: 'bg-blue-100 text-blue-800' }
];

export const formatJoursSemaine = (jours = []) => {
  if (!jours || jours.length === 0) return 'Tous les jours de service';
  if (jours.length === 7) return 'Tous les jours';
  return jours
    .map((jour) => JOURS_SEMAINE.find((j) => j.value === jour)?.court)
    .filter(Boolean)
    .join(', ');
};

export const formatDateForAPI = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const formatDateForDisplay = (date) =>
  date.toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });

export const formatDateCourte = (date) =>
  date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' });

// Lundi de la semaine contenant la date fournie (semaine ISO : lundi -> dimanche)
export const getLundiDeLaSemaine = (date) => {
  const lundi = new Date(date);
  const jourIso = lundi.getDay() === 0 ? 7 : lundi.getDay();
  lundi.setDate(lundi.getDate() - (jourIso - 1));
  lundi.setHours(12, 0, 0, 0);
  return lundi;
};

export const getJoursDeLaSemaine = (lundi) =>
  Array.from({ length: 7 }, (_, index) => {
    const jour = new Date(lundi);
    jour.setDate(lundi.getDate() + index);
    jour.setHours(12, 0, 0, 0);
    return jour;
  });
